export const DESIGN_CATEGORIES = [
	{
		name: "Product design",
		enabled: true,
	},
	{
		name: "Packaging design",
		enabled: true,
	},
	// {
	//   name: "Fashion and textile design (coming in 2021)",
	//   enabled: false,
	// },
	// {
	//   name: "Spatial design (coming in 2021)",
	//   enabled: false,
	// },
] as const;

export const DESIGN_SUBCATEGORIES1 = {
	"Product design": [
		{
			name: "Consumer Electronics",
			enabled: true,
		},
		{
			name: "Furniture (Product Based)",
			enabled: true,
		},
		{
			name: "Home Appliances",
			enabled: true,
		},
		{
			name: "Health & Beauty",
			enabled: true,
		},
		{
			name: "Lighting",
			enabled: true,
		},
		{
			name: "Mobility",
			enabled: true,
		},
		{
			name: "Jewellery & Watches",
			enabled: true,
		},
		{
			name: "Sports, Fitness And Outdoors",
			enabled: true,
		},
		{
			name: "Top-of-table",
			enabled: true,
		},
	],
	"Packaging design": [
		{
			name: "Agriculture",
			enabled: true,
		},
		{
			name: "Alcoholic Beverages",
			enabled: true,
		},
		{
			name: "Baby Feeding & Nutrition",
			enabled: true,
		},
		{
			name: "Carbonated Beverages",
			enabled: true,
		},
		{
			name: "Coffee & Tea",
			enabled: true,
		},
		{
			name: "Diet & Nutrition",
			enabled: true,
		},
		{
			name: "Juice",
			enabled: true,
		},
		{
			name: "Meal Replacement",
			enabled: true,
		},
		{
			name: "Meals",
			enabled: true,
		},
		{
			name: "Snacks",
			enabled: true,
		},
	],
} satisfies {
	[Category in typeof DESIGN_CATEGORIES[number]["name"]]: {
		name: string;
		enabled: boolean;
	}[];
};

export const DESIGN_SUBCATEGORIES2 = {
	"Consumer Electronics": [
		{
			name: "Clocks",
			enabled: true,
		},
		{
			name: "Computers, Laptops & Accesories",
			enabled: true,
		},
		{
			name: "Drones & Flying Objects",
			enabled: true,
		},
		{
			name: "Headphones",
			enabled: true,
		},
		{
			name: "Mobile Phones",
			enabled: true,
		},
		{
			name: "Optics / Photo Accessories",
			enabled: true,
		},
		{
			name: "Safety",
			enabled: true,
		},
		{
			name: "Speakers",
			enabled: true,
		},
		{
			name: "Television",
			enabled: true,
		},
		{
			name: "Video Cameras & Accessories",
			enabled: true,
		},
		{
			name: "Wearable Tech",
			enabled: true,
		},
		{
			name: "Electronic Accessories",
			enabled: true,
		},
		{
			name: "Other",
			enabled: true,
		},
	],
	"Furniture (Product Based)": [
		{
			name: "Bathroom & Sanitary Ware",
			enabled: true,
		},
		{
			name: "Beds",
			enabled: true,
		},
		{
			name: "Cabinets & Bookcases",
			enabled: true,
		},
		{
			name: "Chairs",
			enabled: true,
		},
		{
			name: "Desks",
			enabled: true,
		},
		{
			name: "Kitchen Elements & Furniture",
			enabled: true,
		},
		{
			name: "Tables",
			enabled: true,
		},
		{
			name: "Sofas",
			enabled: true,
		},
		{
			name: "Outdoor Furniture",
			enabled: true,
		},
		{
			name: "Storage & Organization",
			enabled: true,
		},
		{
			name: "Trash & Recycling",
			enabled: true,
		},
		{
			name: "Work & Office",
			enabled: true,
		},
		{
			name: "Other",
			enabled: true,
		},
	],
	"Home Appliances": [
		{
			name: "Freezers, Fridges & Wine Coolers",
			enabled: true,
		},
		{
			name: "Dishwashers",
			enabled: true,
		},
		{
			name: "Ovens, Cooktops & Microwaves",
			enabled: true,
		},
		{
			name: "Vacuum Cleaners & Other Cleaning Equipment",
			enabled: true,
		},
		{
			name: "Washing Machines & Tumble Dryers",
			enabled: true,
		},
		{
			name: "Other Kitchen Appliances",
			enabled: true,
		},
		{
			name: "Other",
			enabled: true,
		},
	],
	"Health & Beauty": [
		{
			name: "Cosmetics & Personal Care",
			enabled: true,
		},
		{
			name: "Medicine",
			enabled: true,
		},
		{
			name: "Wellness",
			enabled: true,
		},
		{
			name: "Other",
			enabled: true,
		},
	],
	Lighting: [
		{
			name: "Ceiling Lamps",
			enabled: true,
		},
		{
			name: "Floor Lamps",
			enabled: true,
		},
		{
			name: "Table Lamps",
			enabled: true,
		},
		{
			name: "Wall Lights",
			enabled: true,
		},
		{
			name: "Other",
			enabled: true,
		},
	],
	Mobility: [
		{
			name: "Automotive",
			enabled: true,
		},
		{
			name: "Boats & Marine",
			enabled: true,
		},
		{
			name: "Motorbikes",
			enabled: true,
		},
		{
			name: "Other Mobility Units",
			enabled: true,
		},
		{
			name: "Other",
			enabled: true,
		},
	],
	"Jewellery & Watches": [
		{ name: "Male Jewellery", enabled: true },
		{ name: "Female Jewellery", enabled: true },
		{
			name: "Other",
			enabled: true,
		},
	],
	"Sports, Fitness And Outdoors": [
		{ name: "Bikes & Cycling", enabled: true },
		{ name: "Fishing & Hunting", enabled: true },
		{ name: "Fitness Machines", enabled: true },
		{ name: "Fitness Equipment", enabled: true },
		{ name: "Outdoors", enabled: true },
		{ name: "Sports", enabled: true },
		{ name: "Swim & Water Sports", enabled: true },
		{
			name: "Other",
			enabled: true,
		},
	],
	"Top-of-table": [
		{ name: "Cups", enabled: true },
		{ name: "Cutlery", enabled: true },
		{ name: "Glasses", enabled: true },
		{ name: "Plates", enabled: true },
		{ name: "Vases", enabled: true },
		{ name: "Kitchen ware", enabled: true },
		{
			name: "Other",
			enabled: true,
		},
	],
} satisfies {
	[Subcategory in
		typeof DESIGN_SUBCATEGORIES1[keyof typeof DESIGN_SUBCATEGORIES1][number]["name"]]: {
		name: string;
		enabled: boolean;
	}[];
};
